import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet-async';
import SiteWrapper from "../../home-pages/SiteWrapper";
import { 
    Grid, 
    Card, 
    CardMedia, 
    Typography, 
    Container,
    Box
} from '@mui/material';
import { photoAlbums } from '../../../data/photoAlbums';

const PictureViewingPage = () => {
    const handleAlbumClick = (album) => {
        // Open Google Photos album in a new tab
        window.open(album.googlePhotosLink, '_blank');
    };

    const title = "Family Photo Albums";

    return (
        <SiteWrapper>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <Container maxWidth="lg" sx={{ mt: 6, mb: 6 }}>
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ color: '#fff', fontFamily: "'Playfair Display', serif', Georgia, serif", fontWeight: 800 }}>
                        Family Photo Albums
                    </Typography>
                    <Typography variant="h6" component="p" align="center" sx={{ color: 'rgba(255, 255, 255, 0.5)', fontWeight: 300 }}>
                        Click on any album to view photos in Google Photos
                    </Typography>
                </Box>

                    <Grid container spacing={4}>
                        {photoAlbums.map((album) => (
                            <Grid item xs={12} sm={6} md={4} key={album.id}>
                                <Card 
                                    sx={{ 
                                        height: 300,
                                        position: 'relative',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s ease-in-out',
                                        '&:hover': {
                                            transform: 'scale(1.05)',
                                            boxShadow: 4
                                        }
                                    }}
                                    onClick={() => handleAlbumClick(album)}
                                >
                                    <CardMedia
                                        component="img"
                                        height="100%"
                                        image={album.thumbnail}
                                        alt={album.title}
                                        sx={{ 
                                            objectFit: 'cover',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%'
                                        }}
                                    />
                                    {/* Dark overlay for better text readability */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-end',
                                            padding: 2
                                        }}
                                    >
                                        <Typography 
                                            variant="h5" 
                                            component="h2" 
                                            sx={{ 
                                                color: 'white',
                                                fontWeight: 'bold',
                                                textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                                                mb: 1
                                            }}
                                        >
                                            {album.title}
                                        </Typography>
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: 'white',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
                                                opacity: 0.9
                                            }}
                                        >
                                            {album.description}
                                        </Typography>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
        </SiteWrapper>
    );
}

export default PictureViewingPage
